<template>
    <div>
        <company-staff-and-permissions
            :store_url="store_url"
            :roles="roles"
            :company_staff_url="company_staff_url"
            ref="company_staff_and_permission"
        ></company-staff-and-permissions>
    </div>
</template>

<script>
    import CompanyStaffAndPermissions from "../people/CompanyStaffAndPermissions";
	export default {
		name: "JobPeopleAndRoleListing",
		components: {CompanyStaffAndPermissions},
		props: [
            'store_url',
            'company_staff_url',
            'roles',
        ],

        data(){
			return {
                keys: Object.keys(this.roles),
            }
        },


        methods: {
            getStaff(){
                this.$refs.company_staff_and_permission.getStaff()
            },
        },
	}
</script>
